import React from 'react';
import PropTypes from 'prop-types';
import CwDropdownMultiItem from './CwDropdownMultiItem';
import css from './CwDropdownMulti.scss';
import scrollIntoView from 'dom-scroll-into-view';

/**
 * Based on react-autocomplete:
 * https://github.com/reactjs/react-autocomplete
 */

class CwDropdownMulti extends React.Component {
  constructor(props) {
    super(props);

    this._mousePosition = { x: 0, y: 0 };
    this._mousedOver = false;
  }

  componentDidUpdate() {
    this.scrollItemIntoView();
  }
  
  scrollItemIntoView() {
    const highlightedItem = this.refs[`item-${this.props.highlightedIndex}`];
    if (highlightedItem) {
      const itemNode = highlightedItem.div;
      const menuNode = this.refs.menu;
      scrollIntoView(
        itemNode,
        menuNode,
        { onlyScrollIfNeeded: true }
      );
    }
  }

  handleItemMouseEnter = (index, enterPosition) => {
    // Don't fire onMouseEnter if mouse didn't actually move (i.e. the dropdown was scrolled by arrow keys)
    if (this.props.onMouseEnter && (this._mousePosition.x !== enterPosition.x || this._mousePosition.y !== enterPosition.y)) {
      this.props.onMouseEnter(index);
    }
  };

  handleItemMouseMove = (position) => {
    this._mousePosition = position;
  }

  handleItemClick = (item) => {
    if (this.props.onClick) {
      this.props.onClick(item);
    }
  };

  handleItemMouseDown = (blur) => {
    if (this.props.onMouseDown) {
      this.props.onMouseDown(blur);
    }
  };

  findValue(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i] === obj.id) {
        return true;
      }
    }
    return false;
  }

  renderItem(item, isHighlighted, index) {
    let isChecked = this.findValue(item, this.props.value);
    return (
      <CwDropdownMultiItem
        isHighlighted={isHighlighted}
        isChecked={isChecked}
        item={item}
        onClick={this.handleItemClick}
        onMouseEnter={this.handleItemMouseEnter}
        onMouseDown={this.handleItemMouseDown}
        onMouseMove={this.handleItemMouseMove}
        index={index}
        key={index}
        ref={`item-${index}`}
      />
    );
  }

  renderToggle(text, isHighlighted, index, isChecked) {
    return (
      <CwDropdownMultiItem
        isHighlighted={isHighlighted}
        isChecked={isChecked}
        item={{ id: index, name: text }}
        onClick={this.handleItemClick}
        onMouseEnter={this.handleItemMouseEnter}
        onMouseDown={this.handleItemMouseDown}
        onMouseMove={this.handleItemMouseMove}
        index={index}
        key={index}
        ref={`item-${index}`}
      />
    );
  }

  isMousedOver = () => {
    return this._mousedOver;
  };

  handleDropdownEnter = () => {
    this._mousedOver = true;
  };

  handleDropdownLeave = () => {
    this._mousedOver = false;
  };

  render() {
    if (this.props.items.length === 0) {
      return (
        <div data-cwid={this.props.cwId} className={css.dropDown} style={this.props.style} />
      );
    }
    else {
      let selectAll = this.renderToggle(this.props.selectAllText, this.props.highlightedIndex === -1, -1, this.props.allSelected);

      let items = this.props.items.map((item, index) => {
        return this.renderItem(
          item,
          this.props.highlightedIndex === index,
          index
        );
      });
      return (
        <div data-cwid={this.props.cwId} className={css.dropDown} style={this.props.style} ref="menu" onMouseEnter={this.handleDropdownEnter} onMouseLeave={this.handleDropdownLeave}>
          {selectAll}
          {items}
        </div>
      );
    }
  }
}

CwDropdownMulti.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Array of items to be listed in the dropdown.
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string
    })
  ),
  /**
   * Index of the currently highlighted item in the dropdown.
   */
  highlightedIndex: PropTypes.number,
  /**
   * Set of style properties to determine the dropdown's size and position. Must contain left, top, and minWidth.
   */
  style: PropTypes.shape({
    left: PropTypes.number,
    top: PropTypes.number,
    minWidth: PropTypes.number
  }),
  /**
   * Callback function that is fired when dropdown is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Callback function that is fired when dropdown is hovered over.
   */
  onMouseEnter: PropTypes.func,
  /**
   * Callback function that is fired before onClick. Typically used to ignore blur in order to prevent dropdown from derezzing before a selection is registered.
   */
  onMouseDown: PropTypes.func,
  /**
   * Text to display on combobox picker
   */
  pickerText: PropTypes.string,
  /**
   * Flag to show it all records have been selected
   */
  allSelected: PropTypes.bool,
  /**
   * Localized text for the Select All option
   */
  selectAllText: PropTypes.string.isRequired
};

export default CwDropdownMulti;


// WEBPACK FOOTER //
// ./src/components/cwdropdown/CwDropdownMulti.jsx